// import React, { useEffect, useState } from "react";
// import {
//   Avatar,
//   Box,
//   Card,
//   CardContent,
//   Typography,
//   Chip,
//   Divider,
// } from "@mui/material";

// export default function StaffProfileCard({ staff, getStaffIsLoading }) {

// //   const [staff,setStaff] = useState({} )

//   useEffect(()=>{
//     // if(staffData){
//     //     console.log(staffData)
//     // setStaff(staff)
//     // }
//   },[staff])

//   if (!staff) return null;

//   const user = staff.staff_user || {};
//   const initials = `${user.first_name?.[0] || ""}${user.last_name?.[0] || ""}`.toUpperCase();

//   return (
//     <Card
//       sx={{
//         maxWidth: 400,
//         borderRadius: 3,
//         boxShadow: 4,
//         overflow: "hidden",
//         backgroundColor: "#fff",
//       }}
//     >
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           p: 3,
//           bgcolor: "#f8f9fa",
//         }}
//       >
//         <Avatar
//           sx={{
//             bgcolor: "#1976d2",
//             width: 72,
//             height: 72,
//             fontSize: 28,
//             mb: 2,
//           }}
//         >
//           {initials}
//         </Avatar>

//         <Typography variant="h6" sx={{ fontWeight: 600 }}>
//           {`${user.first_name || ""} ${user.middle_name || ""} ${user.last_name || ""}`}
//         </Typography>

//         <Typography variant="body2" color="text.secondary">
//           {staff.title}
//         </Typography>

//         <Chip
//           label={staff.staff_status === "active" ? "Active" : "Suspended"}
//           color={staff.staff_status === "active" ? "success" : "error"}
//           size="small"
//           sx={{ mt: 1 }}
//         />
//       </Box>

//       <Divider />

//       <CardContent sx={{ p: 3 }}>
//         <Box sx={{ mb: 1 }}>
//           <Typography variant="subtitle2" color="text.secondary">
//             Team
//           </Typography>
//           <Typography variant="body1">{staff.team || "—"}</Typography>
//         </Box>

//         <Box sx={{ mb: 1 }}>
//           <Typography variant="subtitle2" color="text.secondary">
//             Base
//           </Typography>
//           <Typography variant="body1">{staff.base || "—"}</Typography>
//         </Box>

//         <Box sx={{ mb: 1 }}>
//           <Typography variant="subtitle2" color="text.secondary">
//             Email
//           </Typography>
//           <Typography variant="body1">
//             {user.email || staff.staff_email || "Not provided"}
//           </Typography>
//         </Box>

//         <Box sx={{ mt: 2 }}>
//           <Typography variant="caption" color="text.secondary">
//             Joined on:{" "}
//             {new Date(user.created_at).toLocaleDateString("en-GB", {
//               year: "numeric",
//               month: "long",
//               day: "numeric",
//             })}
//           </Typography>
//         </Box>
//       </CardContent>
//     </Card>
//   );
// }

// ==================================================================================== V2 =============================================================================================
// import React,{useEffect} from "react";
// import {
//   Card,
//   CardContent,
//   Avatar,
//   Typography,
//   Box,
//   Divider,
//   Chip,
//   Skeleton,
// } from "@mui/material";

// const StaffProfileCard = ({ staff, loading }) => {

//   useEffect(()=>{
//     // if(staffData){
//     //     console.log(staffData)
//     // setStaff(staff)
//     // }
//   },[staff,loading])

//   const user = staff.staff_user || {};
//   const initials = user
//     ? `${user.first_name?.[0] || ""}${user.last_name?.[0] || ""}`.toUpperCase()
//     : "";

//   return (
//     <Card
//       sx={{
//         maxWidth: 400,
//         borderRadius: 3,
//         boxShadow: 4,
//         overflow: "hidden",
//         backgroundColor: "#fff",
//       }}
//     >
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           alignItems: "center",
//           p: 3,
//           bgcolor: "#f8f9fa",
//         }}
//       >
//         {loading ? (
//           <Skeleton variant="circular" width={72} height={72} />
//         ) : (
//           <Avatar
//             sx={{
//               bgcolor: "#1976d2",
//               width: 72,
//               height: 72,
//               fontSize: 28,
//               mb: 2,
//             }}
//           >
//             {initials}
//           </Avatar>
//         )}

//         {loading ? (
//           <Skeleton width="60%" height={28} sx={{ mb: 1 }} />
//         ) : (
//           <Typography variant="h6" sx={{ fontWeight: 600 }}>
//             {`${user?.first_name || ""} ${user?.middle_name || ""} ${user?.last_name || ""}`}
//           </Typography>
//         )}

//         {loading ? (
//           <Skeleton width="40%" height={20} />
//         ) : (
//           <Typography variant="body2" color="text.secondary">
//             {staff?.title || "—"}
//           </Typography>
//         )}

//         {!loading && (
//           <Chip
//             label={staff?.staff_status === "active" ? "Active" : "Suspended"}
//             color={staff?.staff_status === "active" ? "success" : "error"}
//             size="small"
//             sx={{ mt: 1 }}
//           />
//         )}
//       </Box>

//       <Divider />

//       <CardContent sx={{ p: 3 }}>
//         {/* Team */}
//         <Box sx={{ mb: 1 }}>
//           <Typography variant="subtitle2" color="text.secondary">
//             Team
//           </Typography>
//           {loading ? (
//             <Skeleton width="80%" height={22} />
//           ) : (
//             <Typography variant="body1">{staff?.team || "—"}</Typography>
//           )}
//         </Box>

//         {/* Base */}
//         <Box sx={{ mb: 1 }}>
//           <Typography variant="subtitle2" color="text.secondary">
//             Base
//           </Typography>
//           {loading ? (
//             <Skeleton width="60%" height={22} />
//           ) : (
//             <Typography variant="body1">{staff?.base || "—"}</Typography>
//           )}
//         </Box>

//         {/* Email */}
//         <Box sx={{ mb: 1 }}>
//           <Typography variant="subtitle2" color="text.secondary">
//             Email
//           </Typography>
//           {loading ? (
//             <Skeleton width="90%" height={22} />
//           ) : (
//             <Typography variant="body1">
//               {user?.email || staff?.staff_email || "Not provided"}
//             </Typography>
//           )}
//         </Box>

//         {/* Joined Date */}
//         <Box sx={{ mt: 2 }}>
//           {loading ? (
//             <Skeleton width="50%" height={18} />
//           ) : (
//             <Typography variant="caption" color="text.secondary">
//               Joined on:{" "}
//               {user?.created_at
//                 ? new Date(user.created_at).toLocaleDateString("en-GB", {
//                     year: "numeric",
//                     month: "long",
//                     day: "numeric",
//                   })
//                 : "—"}
//             </Typography>
//           )}
//         </Box>
//       </CardContent>
//     </Card>
//   );
// };

// export default StaffProfileCard;



// ============================================================End V2 ===================================================


import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Avatar,
  Typography,
  Box,
  Divider,
  Chip,
  Skeleton,
  TextField,
  Stack,
  Button,
  MenuItem,
} from "@mui/material";

const StaffProfileCard = ({ staff, loading, onSave,updateLoading }) => {
  const user = staff?.staff_user || {};

  const initials = user
    ? `${user.first_name?.[0] || ""}${user.last_name?.[0] || ""}`.toUpperCase()
    : "";

  // -------------------------
  //   EDIT MODE STATE
  // -------------------------
  const [isEditing, setIsEditing] = useState(false);

  const [form, setForm] = useState({
    first_name: "",
    middle_name: "",
    last_name: "",
    title: "",
    email: "",
    team: "",
    base: "",
    description:""
  });

  // Populate form when staff changes
  useEffect(() => {
    if (staff) {
      setForm({
        first_name: user?.first_name || "",
        middle_name: user?.middle_name || "",
        last_name: user?.last_name || "",
        title: staff?.title || "",
        email: user?.email || staff?.staff_email || "",
        team: staff?.team || "",
        base: staff?.base || "",
      });
    }
  }, [staff]);

  // Handle form updates
  const handleChange = (e) => {
    setForm((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  // Save handler
  const handleSave = () => {
    onSave?.(staff?.id,form); // parent handles API update
    setIsEditing(false);
  };

  // -------------------------
  //   VIEW MODE COMPONENT
  // -------------------------
  const ViewMode = (
    <Card
      sx={{
        maxWidth: 400,
        borderRadius: 3,
        boxShadow: 4,
        overflow: "hidden",
        backgroundColor: "#fff",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          p: 3,
          bgcolor: "#f8f9fa",
        }}
      >
        {loading ? (
          <Skeleton variant="circular" width={72} height={72} />
        ) : (
          <Avatar
            sx={{
              bgcolor: "#1976d2",
              width: 72,
              height: 72,
              fontSize: 28,
              mb: 2,
            }}
          >
            {initials}
          </Avatar>
        )}

        {loading ? (
          <Skeleton width="60%" height={28} sx={{ mb: 1 }} />
        ) : (
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            {`${user?.first_name || ""} ${user?.middle_name || ""} ${
              user?.last_name || ""
            }`}
          </Typography>
        )}

        {loading ? (
          <Skeleton width="40%" height={20} />
        ) : (
          <Typography variant="body2" color="text.secondary">
            {staff?.title || "—"}
          </Typography>
        )}

        {!loading && (
          <Chip
            label={staff?.staff_status === "active" ? "Active" : "Suspended"}
            color={staff?.staff_status === "active" ? "success" : "error"}
            size="small"
            sx={{ mt: 1 }}
          />
        )}

        {!loading && (
          <Button
            size="small"
            variant="outlined"
            sx={{ mt: 2 }}
            onClick={() => setIsEditing(true)}
            loading = {updateLoading}
          >
            Edit Profile
          </Button>
        )}
      </Box>

      <Divider />

      <CardContent sx={{ p: 3 }}>
        <Box sx={{ mb: 1 }}>
          <Typography variant="subtitle2" color="text.secondary">
            Team
          </Typography>
          {loading ? (
            <Skeleton width="80%" height={22} />
          ) : (
            <Typography variant="body1">{staff?.team || "—"}</Typography>
          )}
        </Box>

        <Box sx={{ mb: 1 }}>
          <Typography variant="subtitle2" color="text.secondary">
            Base
          </Typography>
          {loading ? (
            <Skeleton width="60%" height={22} />
          ) : (
            <Typography variant="body1">{staff?.base || "—"}</Typography>
          )}
        </Box>

        <Box sx={{ mb: 1 }}>
          <Typography variant="subtitle2" color="text.secondary">
            Email
          </Typography>
          {loading ? (
            <Skeleton width="90%" height={22} />
          ) : (
            <Typography variant="body1">
              {user?.email || staff?.staff_email || "Not provided"}
            </Typography>
          )}
        </Box>

        <Box sx={{ mt: 2 }}>
          {loading ? (
            <Skeleton width="50%" height={18} />
          ) : (
            <Typography variant="caption" color="text.secondary">
              Joined on:{" "}
              {user?.created_at
                ? new Date(user.created_at).toLocaleDateString("en-GB", {
                    year: "numeric",
                    month: "long",
                    day: "numeric",
                  })
                : "—"}
            </Typography>
          )}
        </Box>
      </CardContent>
    </Card>
  );

  // -------------------------
  //   EDIT MODE COMPONENT
  // -------------------------
  const EditMode = (
    <Card
      sx={{
        maxWidth: 400,
        borderRadius: 3,
        boxShadow: 4,
        p: 3,
      }}
    >
      <Typography variant="h6" fontWeight={600} mb={2}>
        Edit Staff Profile
      </Typography>

      <Stack spacing={2}>
        <TextField
          label="First Name"
          name="first_name"
          value={form.first_name}
          onChange={handleChange}
          fullWidth
        />
        <TextField
          label="Middle Name"
          name="middle_name"
          value={form.middle_name}
          onChange={handleChange}
          fullWidth
        />
        <TextField
          label="Last Name"
          name="last_name"
          value={form.last_name}
          onChange={handleChange}
          fullWidth
        />
        <TextField
          label="Title"
          name="title"
          value={form.title}
          onChange={handleChange}
          fullWidth
        />
        {/* <TextField
          label="Team"
          name="team"
          value={form.team}
          onChange={handleChange}
          fullWidth
        /> */}
        
        <TextField
              select
              fullWidth
              label="Team"
              name="team"
              value={form.team}
              onChange={handleChange}
              margin="normal"
              required
            >
                <MenuItem value="" disabled>
                    -- Select/Change Team --
                </MenuItem>
                <MenuItem value="Executive Leadership Team">
                Executive Leadership Team
                </MenuItem>
                <MenuItem value="Senior Leadership Team">
                Senior Leadership Team
                </MenuItem>
                <MenuItem value="Board of Management">
                Board of Management
                </MenuItem>
                <MenuItem value="Advisory Committee">
                Advisory Committee
                </MenuItem>
                <MenuItem value="Organisation Team">
                Team Member
                </MenuItem>
            </TextField>
        
        <TextField
          label="Base"
          name="base"
          value={form.base}
          onChange={handleChange}
          fullWidth
        />
        <TextField
          label="Email"
          name="email"
          value={form.email}
          onChange={handleChange}
          fullWidth
        />
        {
          form?.team === "Executive Leadership Team"?(
            <TextField
            fullWidth
            label="Executive Leadership Description"
            name="description"
            value={form.description}
            onChange={handleChange}
            margin="normal"
            required
            multiline
            minRows={5}
            rows={5}
          ></TextField>
          ):""

        }

        <Stack direction="row" spacing={2} justifyContent="flex-end">
          <Button variant="outlined" onClick={() => setIsEditing(false)}>
            Cancel
          </Button>

          <Button variant="contained" onClick={handleSave}>
            Save Changes
          </Button>
        </Stack>
      </Stack>
    </Card>
  );

  return isEditing ? EditMode : ViewMode;
};

export default StaffProfileCard;

           